<mat-dialog-content [ngClass.xs]="'w-mobile'" [ngClass.gt-xs]="'w-desktop'">
  <div style="text-align: center"><img style="width: 180px" src="https://wickedlist.com/b/wp-content/uploads/2019/11/logo.png"></div>
  <div class="thx-text" style="text-align: center; padding-top: 20px; padding-bottom: 40px">
    We've updated the website. The page will be reloaded.
  </div>

  <div style="text-align: center">
    <button class="d-flex justify-content-center p-1 m-auto" style="width: 130px;" mat-raised-button color="primary" (click)="closeAction()"><span *ngIf="!reloading">OK</span><mat-spinner color="accent" *ngIf="reloading" diameter="30"></mat-spinner></button>
  </div>
    

</mat-dialog-content>

